import React from 'react';
import Img_logo from '../images/plan.png';

export default () => (
	<div className='section1-CN'>

		<div class="service-split">
			<img class="service-split-img" src={Img_logo}></img>
			<div>
				<h4>
					Pre-Construction
				</h4>
				<p>
					1. Site & Opportunity Review:
					Whether you’re a landowner with a vacant infill lot or a capital holder looking at a potential site, we start by reviewing the land itself… location, zoning, lot size, surrounding context, and how much rental housing it can realistically support… whether the lot is bare or comes with an existing dwelling that may stay while we add new housing beside or behind it.		</p>
				<p>
					2. High-Level Feasibility & Concept:
					We sketch an initial concept and ballpark budget to test if the idea makes sense… unit count, likely height, parking approach, and a rough sense of project costs and value, so you know early if the site is worth moving forward on.
				</p>
				<p>
					3. Land Acquisition & Ownership Support:
					If you’re a capital holder acquiring a site, we help you move from “idea” to ownership by coordinating with our recommended realtor and legal team during the purchase process. If you’re a landowner who already holds the lot, we support you through any required title work, severances, or adjustments. We don’t trade land… we manage the development side while our recommended licensed professionals handle the transaction.
				</p>
				<p>
					4. Detailed Site Assessment:
					Survey, grading, servicing, nearby trees, utilities, and constraints… we dig into how the lot actually behaves so there are fewer surprises later, whether we’re working around an existing dwelling or planning for a clean build on open land.
				</p>
				<p>
					5. Planning & Building Strategy:
					We map out how to get the most out of the land within… or strategically beyond… the existing zoning. This is where we decide whether to add new units behind or beside an existing dwelling that stays, or move toward a full ground-up build, always tying the approach back to the goals and the site’s reality.
				</p>
				<p>
					6. Design & Drawings:
					Working with architects and engineers, we turn the concept into real drawings… floor plans, elevations, servicing plans, and technical details that respond to both the by-law and the way people actually live on infill sites.
				</p>
				<p>
					7. Zoning Relief & Committee of Adjustment:
					If the best version of the project needs minor variances or by-law relief, we prepare and manage the Committee of Adjustment process… coordinating reports, engaging consultants, and presenting a clear planning rationale on your behalf.
				</p>
				<p>
					8. Approvals & Permits:
					We manage the application process with the City… site plan (where required), building permits, and coordination with reviewers until the green light is in place to start building.
				</p>
				<p>
					9. Final Budgeting & Financing Support:
					With design and approvals in hand, we refine the budget and help structure the project so our recommended financing partners can underwrite it with confidence. We’re not mortgage brokers or lenders, but we work closely with them to make sure the numbers and the plan line up.
				</p>
				<p>
					10. Contractor & Trade Coordination:
					We assemble and coordinate the construction team… general contractors, key trades, and consultants. Our role is to keep everyone aligned with the approved drawings, budget, and schedule.
				</p>
				<p>11. Pre-Construction Setup:
					Before anyone starts digging, we line up logistics… site access, staging, safety, utilities, and sequencing so construction can move efficiently instead of chaotically.</p>
			</div>
		</div>
	</div>
);
